import React from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from '@perxis-auto/ui-kit/lib/components/Filter';

import useFiltersData from '@/features/filters/hooks/useFiltersData';
import { useAppDispatch, useAppSelector } from '@/features/hooks';
import { rootActions, rootSelectors } from '@/features/store';
import { IExtendedChoiceHistoryItem } from '@/interfaces/choice.interfaces';

import { FilterHistoryProps } from './FilterHistory.types';

import styles from './FilterHistory.module.scss';

function FilterHistory(props: FilterHistoryProps) {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const { currentData, data: filters = currentData } = useFiltersData();

  const historyItems = useAppSelector(state =>
    rootSelectors.choice.historyItemsSelector(state, {
      filtersData: filters?.data,
    }),
  );

  const handleClick = ({ key, valueOnDeletion }: IExtendedChoiceHistoryItem) => {
    return () => {
      dispatch(rootActions.choice.setFilters({ [key]: valueOnDeletion }));
    };
  };

  const handleReset = () => {
    dispatch(rootActions.choice.resetFilters());
  };

  if (!historyItems.length) {
    return null;
  }

  return (
    <div className={styles.filterHistory}>
      {historyItems.map((historyItem: IExtendedChoiceHistoryItem) => (
        <Filter
          key={`${historyItem.key}-${historyItem.value}`}
          onClick={handleClick(historyItem)}
          className={styles.filter}
        >
          {historyItem.label}
        </Filter>
      ))}
      <Filter key="reset" reset onClick={handleReset} className={styles.filter}>
        {t('filterHistory.reset')}
      </Filter>
    </div>
  );
}

export default FilterHistory;
